var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHappyEmoji(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1753_78883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 42.4319C2.35968 42.4132 -7.0167 19.7751 6.15106 6.58267C13.9676 -1.56309 28.0327 -1.5644 35.8492 6.58299C49.0168 19.7768 39.6394 42.4143 21.0001 42.4319ZM21.0001 2.23675C10.4158 2.23675 1.80482 10.8477 1.80482 21.432C2.85924 46.8971 39.1447 46.8896 40.1953 21.4318C40.1953 10.8477 31.5843 2.23675 21.0001 2.23675Z",
    fill: "url(#paint0_linear_1753_78883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 2.23675C10.4158 2.23675 1.80482 10.8477 1.80482 21.432C2.85924 46.8971 39.1447 46.8896 40.1953 21.4318C40.1953 10.8477 31.5843 2.23675 21.0001 2.23675Z",
    fill: "url(#paint1_linear_1753_78883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1064 14.6676C11.919 14.6676 10.9531 15.6335 10.9531 16.8208C11.0714 19.6774 15.1417 19.6766 15.2596 16.8208C15.2596 15.6334 14.2936 14.6676 13.1064 14.6676Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.453 14.6676C27.2657 14.6676 26.2998 15.6335 26.2998 16.8208C26.4181 19.6774 30.4884 19.6766 30.6063 16.8208C30.6063 15.6334 29.6403 14.6676 28.453 14.6676Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0167 34.3682C15.8499 34.3682 11.2138 31.1808 9.20552 26.2477C9.01759 25.7862 9.23948 25.2596 9.70107 25.0718C10.1626 24.8838 10.6891 25.1057 10.877 25.5673C12.6073 29.8174 16.5873 32.5636 21.0167 32.5636C25.4461 32.5636 29.4261 29.8174 31.1564 25.5673C31.3444 25.1057 31.8709 24.8837 32.3323 25.0718C32.7939 25.2597 33.0157 25.7862 32.8279 26.2477C30.8196 31.1808 26.1835 34.3682 21.0167 34.3682Z",
    fill: "#2D2D2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1753_78883",
    x1: 2.809,
    y1: 31.9465,
    x2: 39.1732,
    y2: 10.9319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ECB64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEC04F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F1CC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D652"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1753_78883",
    x1: 2.809,
    y1: 31.9465,
    x2: 39.1732,
    y2: 10.9319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ECB64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEC04F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F1CC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D652"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1753_78883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0 0.452393)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyEmoji);
export default __webpack_public_path__ + "static/media/happy-emoji.ce3ac6e9c0f0f23ed01e87a577343907.svg";
export { ForwardRef as ReactComponent };